export const CUSTOMER_SURVEY_REQUEST_ACTIVITY_EVENT = 'customer-survey:request-activity';

const PENDING_REQUEST_ID_KEY = 'customer_survey_pending_request_id';

export type CustomerSurveyRequestActivityDetail = {
  requestId?: string | number;
};

export function readPendingCustomerSurveyRequestId(): string | null {
  try {
    return sessionStorage.getItem(PENDING_REQUEST_ID_KEY);
  } catch {
    return null;
  }
}

export function clearPendingCustomerSurveyRequestId(): void {
  try {
    sessionStorage.removeItem(PENDING_REQUEST_ID_KEY);
  } catch {
    return;
  }
}

function writePendingCustomerSurveyRequestId(value: string | number): void {
  try {
    sessionStorage.setItem(PENDING_REQUEST_ID_KEY, String(value));
  } catch {
    return;
  }
}

export function notifyCustomerSurveyRequestActivity(
  detail: CustomerSurveyRequestActivityDetail = {},
): void {
  if (typeof window === 'undefined') return;

  if (detail.requestId !== undefined && detail.requestId !== null) {
    writePendingCustomerSurveyRequestId(detail.requestId);
  }

  window.dispatchEvent(
    new CustomEvent<CustomerSurveyRequestActivityDetail>(
      CUSTOMER_SURVEY_REQUEST_ACTIVITY_EVENT,
      { detail },
    ),
  );
}
